module.exports = __webpack_public_path__ + "img/link-file.ae76489a.svg";